import { render, staticRenderFns } from "./ConsultantsList.vue?vue&type=template&id=36c661f8&scoped=true"
import script from "./ConsultantsList.vue?vue&type=script&lang=js"
export * from "./ConsultantsList.vue?vue&type=script&lang=js"
import style0 from "./ConsultantsList.vue?vue&type=style&index=0&id=36c661f8&prod&lang=scss&scoped=true"
import style1 from "./ConsultantsList.vue?vue&type=style&index=1&id=36c661f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c661f8",
  null
  
)

export default component.exports